import Amendment from './items/Amendment';
import CorpFormation from './items/CorpFormation';
import DomainNameRegistration from './items/DomainNameRegistration';
import EINCreation from './items/EINCreation';
import EmailAddress from './items/EmailAddress';
import GoodStanding from './items/GoodStanding';
import LLCFormation from './items/LLCFormation';
import NYPublication from './items/NYPublication';
import RegisteredAgentService from './items/RegisteredAgentService';
import WorryFreeGuarantee from './items/WorryFreeGuarantee';

export const PLAN_PRODUCTS = {
  llc_annual_report: {
    title: 'orderView.product.annualReport.title',
    hasDetails: false,
    description: 'orderView.product.annualReport.description'
  },
  corp_annual_report: {
    title: 'orderView.product.annualReport.title',
    hasDetails: false,
    description: 'orderView.product.annualReport.description'
  },
  annual_report_service: {
    title: 'orderView.product.annualReport.title',
    hasDetails: false,
    description: 'orderView.product.annualReport.description'
  },
  registered_agent_service: {
    title: 'orderView.product.registeredAgent.title',
    description: 'orderView.product.registeredAgent.description',
    hasDetails: true,
    ViewModal: RegisteredAgentService
  },
  operating_agreement: {
    title: 'orderView.product.operatingAgreement.title',
    description: 'orderView.product.operatingAgreement.description',
    hasDetails: false
  },
  banking_resolution: {
    title: 'orderView.product.bankingResolution.title',
    description: 'orderView.product.bankingResolution.description',
    hasDetails: false
  },
  domain_name_reg: {
    title: 'orderView.product.domainName.title',
    description: 'orderView.product.domainName.description',
    hasDetails: true,
    ViewModal: DomainNameRegistration
  },
  domain_name_privacy: {
    title: 'orderView.product.domainPrivacy.title',
    description: 'orderView.product.domainPrivacy.description',
    hasDetails: false
  },
  rush: {
    title: 'orderView.product.rushFiling.title',
    description: '',
    hasDetails: false
  },
  static_website: {
    title: 'orderView.product.website.title',
    description: 'orderView.product.website.description',
    hasDetails: false
  },
  worry_free_service: {
    title: 'orderView.product.worryFreeCompliance.title',
    description: 'orderView.product.worryFreeCompliance.description',
    hasDetails: true,
    ViewModal: WorryFreeGuarantee
  },
  ein_creation: {
    title: 'orderView.product.ein.title',
    description: 'orderView.product.ein.description',
    hasDetails: true,
    ViewModal: EINCreation
  },
  basic_email: {
    title: 'orderView.product.email.title',
    description: 'orderView.product.email.description',
    ViewModal: EmailAddress,
    hasDetails: true
  },
  llc_formation: {
    title: 'orderView.product.stateFilingFee.title',
    description: 'orderView.product.stateFilingFee.description',
    hasDetails: true,
    ViewModal: LLCFormation
  },
  corp_formation: {
    title: 'orderView.product.stateFilingFee.title',
    description: 'orderView.product.stateFilingFee.description',
    hasDetails: true,
    ViewModal: CorpFormation
  },
  expedite: {
    title: 'orderView.product.expediteFiling.title',
    description: '',
    hasDetails: false
  },
  logo_kit: {
    title: 'orderView.product.logoKit.title',
    description: 'orderView.product.logoKit.description',
    hasDetails: false
  },
  ny_publication: {
    title: 'orderView.product.publication.title',
    description: 'orderView.product.publication.description',
    hasDetails: true,
    ViewModal: NYPublication
  },
  corporate_docs: {
    title: 'orderView.product.documentTemplates.title',
    description: 'orderView.product.documentTemplates.description',
    hasDetails: false
  },
  standard_good_standing: {
    title: 'orderView.product.goodStanding.title',
    description: 'orderView.product.goodStanding.description',
    hasDetails: true,
    ViewModal: GoodStanding
  },
  llc_amendment: {
    title: 'orderView.product.amendment.title',
    description: 'orderView.product.amendment.description',
    hasDetails: true,
    ViewModal: Amendment
  },
  corp_amendment: {
    title: 'orderView.product.amendment.title',
    description: 'orderView.product.amendment.description',
    hasDetails: true,
    ViewModal: Amendment
  },
  expedite_to_rush_upgrade: {
    title: 'orderView.product.expediteToRush.title',
    description: '',
    hasDetails: false
  },
  website_tools_bundle: {
    title: 'orderView.product.websiteToolsBundle.title',
    description: '',
    hasDetails: false
  },
  zb_money_pro: {
    title: 'orderView.product.moneyPro.title',
    description: 'orderView.product.moneyPro.description',
    hasDetails: false
  },
  business_license_report: {
    title: 'orderView.product.businessLicenseReport.title',
    description: 'orderView.product.businessLicenseReport.description',
    hasDetails: false
  },
  '1800_accountant': {
    title: 'orderView.product.taxSavingsConsultation.title',
    description: 'orderView.product.taxSavingsConsultation.description',
    hasDetails: false
  }
};
